import { SimpleModalProps } from '../../modals/simpleModal'
import { useTranslator } from '../../translator/hook'
import Modal from 'react-modal'
import { BigButton } from '../../buttons/bigButton'
import '../../../styles/modal.css'
import './howToPlayModal.css'
import howToPlayImg from '../../../assets/how-to-play.svg'
import { SetupSlideModal } from './setupSlideModal'
import { useContext, useState } from 'react'
import { UserContext } from '@/components/user/provider'

interface HowToPlayModalProps extends Pick<SimpleModalProps, 'onClose'> {
  isOpen: boolean
  onClose(): void
}

export const HowToPlayModal = ({ isOpen, onClose }: HowToPlayModalProps) => {
  Modal.setAppElement('#root')
  const { t } = useTranslator()
  const { isOnlineUser } = useContext(UserContext)

  const [showSetupModal, setShowSetupModal] = useState(false)

  const handleSetupModalClose = () => {
    setShowSetupModal(false)
  }

  return (
    <>
      <SetupSlideModal
        isOpen={showSetupModal}
        onClose={handleSetupModalClose}
      />
      <Modal
        className="modal-content"
        isOpen={isOpen}
        contentLabel="How to play Modal"
        onRequestClose={onClose}
        style={{
          overlay: {
            alignItems: 'center',
            display: 'flex',
            justifyContent: 'center',
            zIndex: 861,
          },
        }}
      >
        <div className="how-to-play-modal-container">
          <div className="how-to-play-modal-header">
            <div className="how-to-play-modal-title"></div>
          </div>

          <div className="how-to-play-modal-content">
            <div className="how-to-play-modal-card">
              <div className="how-to-play-modal-card-title">
                {t('how_to_play_modal_title')}
              </div>
              <div className="how-to-play-modal-card-image">
                <img src={howToPlayImg} alt={'howToPlay'} />
              </div>
            </div>
          </div>
          <div className="how-to-play-modal-footer-text">
            {t('how_to_play_help1')}
            <a
              onClick={() => {
                if (isOnlineUser) {
                  setShowSetupModal(true)
                } else {
                  window.open(
                    `${import.meta.env.VITE_DIGITANE_LICENSE_URL}/mission/rj1/setup/`,
                    '_blank',
                    'noopener,noreferrer',
                  )
                }
              }}
              className="setup-link"
            >
              {t('how_to_play_help2')}
            </a>
            {t('how_to_play_help3')}
          </div>
        </div>
        <div>
          <BigButton onClick={onClose}>{t('close_button')}</BigButton>
        </div>
      </Modal>
    </>
  )
}
